import * as actionTypes from "../constants/actionTypes";
import * as componentTypes from "../constants/componentTypes";
import * as modelHelper from "../helpers/modelHelper";
import * as reducerHelper from "../helpers/reducerHelper";

const initialState = {
    masterProduct: false,
    masterProductName: null,
    baseList: [],
    masterProductList: [],
    matchingFormula: false
};

export const customTabReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.CUSTOM_TAB_INIT:
        case actionTypes.CLONE_MAIN_TO_CUSTOM_TAB:
        case actionTypes.CLONE_MATCHING_TO_CUSTOM_TAB:
        case actionTypes.CLONE_HISTORY_TO_CUSTOM_TAB:
        case actionTypes.MATCHING_TAB_INIT_DRAFT_FORMULA_SCENE:
            if (state[action.payload.tabId] !== undefined) {
                return state;
            }
            let customFormulaTab = reducerHelper.getLastTabByType(
                action.payload.tabList ?? [],
                componentTypes.CUSTOM_TAB
            );
            let customFormulaTabId = customFormulaTab !== null ? customFormulaTab.id : action.payload.tabId;

            let customInitialState = {};
            customInitialState[customFormulaTabId] = {...initialState};

            if (window.storeProvider.getCustomFormulaForMasterProductDefault() !== null) {
                customInitialState[customFormulaTabId].masterProduct =
                    window.storeProvider.getCustomFormulaForMasterProductDefault();
            }

            if (
                action.type === actionTypes.CLONE_MATCHING_TO_CUSTOM_TAB ||
                action.type === actionTypes.MATCHING_TAB_INIT_DRAFT_FORMULA_SCENE
            ) {
                customInitialState[customFormulaTabId].matchingFormula = true;
            }

            return {...state, ...customInitialState};
        case actionTypes.CLOSE_ACTIVE_TAB:
        case actionTypes.CLOSE_ALL_TABS_EXCEPT_ACTIVE:
        case actionTypes.CLOSE_ALL_TABS:
            let finalState = {};

            let tab;
            for (tab of action.payload.newTabList) {
                if (state[tab.id] !== undefined) {
                    finalState[tab.id] = state[tab.id];
                }
            }

            return finalState;
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.DATABASE_CHANGE:
            return {};
        case actionTypes.CUSTOM_TAB_SAVE_BASE_LIST:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    baseList: modelHelper.mapBasesToObjects(action.payload.baseList)
                },
                state
            );
        case actionTypes.CUSTOM_TAB_REMOVE_SELECTED_PRODUCT:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    masterProductName: null,
                    baseList: [],
                    masterProductList: []
                },
                state
            );
        case actionTypes.CUSTOM_TAB_SET_MASTER_PRODUCT:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    masterProduct: action.payload.masterProduct
                },
                state
            );
        case actionTypes.CUSTOM_TAB_SAVE_MASTER_PRODUCT_NAME:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    masterProductName: action.payload.masterProductName
                },
                state
            );
        case actionTypes.CUSTOM_TAB_SAVE_MASTER_PRODUCT_LIST:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    masterProductList: modelHelper.mapMasterProductsToObjects(action.payload.masterProductList)
                },
                state
            );
        default:
            return state;
    }
};
